/* eslint-disable @typescript-eslint/no-explicit-any */
import { downloadBlob } from 'components/helpcomponents/blob';
import downloadjs from 'downloadjs';
import Swal from 'sweetalert2';
import { Service } from '../../services/Service';
import { settings } from './APISettings';

const apiSettings = await settings;
const baseUri = apiSettings.apiBaseUrl;

export default class APIFetcher extends Service {

  async commonGet(uri) {
    const response = await this.client.get(baseUri + uri);

    if (response.status >= 200 && response.status <= 299) {
      const data = response.data;

      return data;

    } else if (response.status === 403) {
      alert('You do not have permission to view this page');
    } else {
      alert('Something went wrong..');
    }
  }

  async commonPost(uri, obj) {
    const response = await this.client.post(baseUri + uri, JSON.stringify(obj));
    if (response.status >= 200 && response.status <= 299) {
      const data = response.data;

      return data;

    } else if (response.status === 403) {
      alert('You do not have permission to view this page');
    } else {
      alert('Something went wrong..');
    }
  }

  async getUsersInApplication() {
    return await this.commonGet('User/GetAllApplicationUsers')
  }

  async getAllUsersInCompany() {
    return await this.commonGet('User/GetAllCompanyUsers')
  }

  async addUserToRole(obj) {
    return await this.commonPost('User/AddUserToRole', obj)
  }

  async removeUserFromRole(obj) {
    return await this.commonPost('User/RemoveUserFromRole', obj)
  }

  async removeUserFromApplication(obj) {
    return await this.commonPost('User/RemoveUserFromApplication', obj)
  }

  async getUsersGroups(obj) {
    return await this.commonPost('Group/GetUsersGroups', obj)
  }

  async getAllApplicationGroups() {
    return await this.commonGet('Group/GetApplicationGroups')
  }

  async getUsersInGroup(obj) {
    return await this.commonPost('Group/GetUsersInGroup', obj)
  }

  async getApplicationBusinessAreas() {
    return await this.commonGet('BusinessArea/GetApplicationBusinessAreas')
  }

  async getUsersBusinessAreas(obj) {
    return await this.commonPost('BusinessArea/GetUsersBusinessAreas', obj)
  }

  async getUsersInBusinessArea(obj) {
    return await this.commonPost('BusinessArea/GetUsersInBusinessArea', obj)
  }

  async addUserToBusinessArea(obj) {
    return await this.commonPost('BusinessArea/AddUserToBusinessArea', obj)
  }

  async removeUserFromBusinessArea(obj) {
    return await this.commonPost('BusinessArea/RemoveUserFromBusinessArea', obj)
  }

  async getPermissions() {
    return await this.commonGet('Permission/List')
  }

  async createPermission(obj) {
    return await this.commonPost('Permission', obj) //de kan vara samma.. men nån gång kanske de inte vill vara det.
  }

  async updatePermission(obj) {
    return await this.commonPost('Permission', obj) //de kan vara samma.. men nån gång kanske de inte vill vara det.
  }

  async getUserPermissions(userId) {
    return await this.commonGet('Permission/User/' + userId)
  }

  async removeUserPermission(obj) {
    return await this.commonPost('Permission/User/Remove', obj)
  }

  async removePermission(obj) {
    return await this.commonPost('Permission/Remove', obj)
  }

  async addUserPermission(obj) {
    return await this.commonPost('Permission/User/Add', obj)
  }

  async getLoggedInUsersGroups() {
    const response = await this.client.get(baseUri + 'Me/GetLoggedInUsersGroups');
    if (response.status >= 200 && response.status <= 299) {
      const data = response.data;
      return data;
    } else if (response.status === 403) {
      alert('You do not have permission to view this page');
    } else if (response.status === 500) {
      return 500;
    }
  }

  async getLoggedInUsersPermissions() {
    return await this.commonGet('Me/GetLoggedInUsersPermissions')
  }



  async postFile(data) {
    const response = await this.client.post(baseUri + 'Laundry/PostFile', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (response.status >= 200 && response.status <= 299 && response.status !== 204) {
      const data = response.data;
      return data;
    } else {
      return '500';
    }
  }

  async getUserImportStatus(data) {
    const response = await this.client.post(baseUri + 'Laundry/GetUserImportStatus', JSON.stringify(data));
    if (response.status === 204) {
      return '204';
    } else if (response.status >= 200 && response.status <= 299) {
      const data = response.data;
      return data;
    } else {
      return '500';
    }
  }

  async postEmails(market, emails) {
    const response = await this.client.post(baseUri + 'Laundry/PostEmails?market=' + market, JSON.stringify(emails));
    if (response.status >= 200 && response.status <= 299) {
      const data = response.data;
      return data;
    } else {
      return '500';
    }
  }

  async listImportStatus(obj) {
    const response = await this.client.post(baseUri + 'Laundry/ListImportStatus', JSON.stringify(obj));
    if (response.status >= 200 && response.status <= 299) {
      const data = response.data;
      if (data.Success === false) {
        alert('Unexpected error..');
        return 'Not found';
      }
      return data;
    } else if (response.status === 400) {
      return '400';
    } else if (response.status === 500) {
      return '500';
    }
  }

  async getLaundryUserByCompanyId(obj) {
    const response = await this.client.post(baseUri + 'Laundry/PostCompanyForUsers', JSON.stringify(obj));
    if (response.status >= 200 && response.status <= 299 && response.status !== 204) {
      const data = response.data;
      return data;
    } else if (response.status === 204) {
      return '204';
    } else {
      return '500';
    }
  }

  async getAdminContactInfo() {
    return await this.commonGet('ContactInfo/GetAdminContactInfo');
  }

  async getSalesContactInfo() {
    return await this.commonGet('ContactInfo/GetSalesContactInfo');
  }

  async getExportContactInfo() {
    return await this.commonGet('ContactInfo/GetExportContactInfo');
  }

  async getLaundryContactInfo() {
    return await this.commonGet('ContactInfo/GetLaundryContactInfo');
  }

  async getContactData() {
    return await this.commonGet('ContactInfo/GetContactInfo');
  }

  async getProfilePictures() {
    const response = await this.client.get(baseUri + 'ContactInfo/GetProfilePic', { responseType: 'blob' });
    if (response.status >= 200 && response.status <= 299) {
      const data = response.data;
      return data;
    } else if (response.status === 403) {
      alert('You do not have permission to view this page');
    } else {
      return 500;
    }
  }

  async getReportsList() {
    return await this.commonGet('Laundry/GetReportsList');
  }

  async downloadFile(file, uri) {
    await this.client
      .post(baseUri + uri, uri === 'Laundry/CreateStormImportfile' ? file : JSON.stringify(file), {
        headers: uri === 'Laundry/CreateStormImportfile' ? { 'Content-Type': 'multipart/form-data' } : {},
        timeout: 90000,
      })
      .then(response => {
        if (response.status >= 200 && response.status <= 299) {
          const regex = /\[(.*?)\]/;
          const contentDisposition = (response.headers as any)?.get('content-disposition');
          const fileName =
            uri === 'BMECat/GetBMECatFile' ? file.CustomerNo : decodeURI((regex.exec(contentDisposition) as any)[1]); // gets the file name from content-disposition
          return response.data.then(body => {
            if (uri === 'BMECat/GetBMECatFile' && body.size < 9999) {
              // If bodysize < 9999 - Which it is if BMECat is corrupt.
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                showCloseButton: true,
                text: 'No file exported. Check inputfields in form and try again..',
              });
            } else if (uri === 'BMECat/GetBMECatFile') {
              downloadjs(body, fileName + '.xml', 'application/octet-stream');
            } else if (uri === 'Laundry/CreateStormImportfile') {
              downloadjs(body, fileName, 'text/csv');
            } else {
              downloadjs(body, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'); // downloads the file returned.
            }
          });
        } else if (response.status === 403) {
          alert('You do not have permission to view this page'); // error msg if you somehow accsesed the api without having permission to laundry.
          window.location.reload();
        } else if (response.status === 300) {
          // msg if no file is returned.
          if (uri === 'Laundry/CreateStormImportfile') {
            Swal.fire({
              icon: 'error',
              title: 'Wrong properties in excelfile.',
              showCloseButton: true,
              text: 'Wrong properties in excelfile. Please edit and try again',
              footer: '<p>Check the instructions for more information</p>',
            });
          } else {
            Swal.fire({
              icon: 'info',
              title: 'Empty result',
              showCloseButton: true,
              text: 'No file could be found on these parameters!',
            });
          }
        } else if (response.status === 502 && uri === 'Laundry/CreateStormImportfile') {
          // general error msg.
          Swal.fire({
            icon: 'error',
            title: 'oops...',
            showCloseButton: true,
            text: 'Wrong properties in excelfile. Please edit and try again',
            footer: '<p>Check the instructions for more information</p>',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            showCloseButton: true,
            text: 'Something went wrong, contact an administrator',
          });
        }
      });
  }

  async downloadStormImportFile(file, uri) {
    await this.client
      .post(baseUri + uri, file, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 90000,
      })
      .then(response => {
        if (response.status >= 200 && response.status <= 299) {
          const regex = /\[(.*?)\]/;
          const contentDisposition = (response.headers as any)?.get('content-disposition');
          const fileName = decodeURI((regex.exec(contentDisposition) as any)[1]); // gets the file name from content-disposition
          return downloadjs(response.data, fileName, 'text/csv');
        } else if (response.status === 403) {
          alert('You do not have permission to view this page'); // error msg if you somehow accsesed the api without having permission to laundry.
          window.location.reload();
        } else if (response.status === 300) {
          // msg if no file is returned.
          Swal.fire({
            icon: 'error',
            title: 'Wrong properties in excelfile.',
            showCloseButton: true,
            text: 'Wrong properties in excelfile. Please edit and try again',
            footer: '<p>Check the instructions for more information</p>',
          });
        } else if (response.status === 502) {
          // general error msg.
          Swal.fire({
            icon: 'error',
            title: 'oops...',
            showCloseButton: true,
            text: 'Wrong properties in excelfile. Please edit and try again',
            footer: '<p>Check the instructions for more information</p>',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            showCloseButton: true,
            text: 'Something went wrong, contact an administrator',
          });
        }
      });
  }

  async downloadLaundryReport(obj) {
    await this.client
      .post('Laundry/DownloadLaundryReport', JSON.stringify(obj), {
        timeout: 90000,
        responseType: 'blob',
      })
      .then(response => {
        if (response.status >= 200 && response.status <= 299) {
          downloadBlob(response.data, response.headers);
        } else if (response.status === 403) {
          alert('You do not have permission to view this page'); // error msg if you somehow accsesed the api without having permission to laundry.
          window.location.reload();
        } else if (response.status === 300) {
          // msg if no file is returned.
          Swal.fire({
            icon: 'info',
            title: 'Empty result',
            showCloseButton: true,
            text: 'No file could be found on these parameters!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            showCloseButton: true,
            text: 'Something went wrong, contact an administrator',
          });
        }
      });
  }
}
